import React from 'react';
import { Col } from 'antd';
import StatCard from '@components/StatCard';
import { CalendarOutlined, PhoneOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { getLocaleString } from '@utils/locales';
import { ContainerRow } from './styles';

interface ITBDetails {
  device: {
    deviceModel: string;
    deviceNumber: string;
    iccid: string;
    imsi: string;
    operator: string;
    update: string;
    _class: string;
    gsignal: string;
    field60: string;
  };
}

const statsFontSize = 20;

const TabPanesDetails: React.FC<ITBDetails> = ({ device: deviceProps }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation(['connected-devices']);

  return (
    <ContainerRow gutter={[12, 12]}>
      <Col lg={12} xs={24}>
        <StatCard
          title={t('table.deviceNumber')}
          value={deviceProps?.deviceNumber || '-'}
          icon={<PhoneOutlined />}
          loading={!deviceProps}
        />
      </Col>
      <Col lg={12} xs={24}>
        <StatCard
          title={t('table.operator')}
          icon={<PhoneOutlined />}
          value={deviceProps?.operator || deviceProps?.operator || '-'}
          loading={!deviceProps}
        />
      </Col>
      <Col lg={12} xs={24}>
        <StatCard
          title={t('table.model')}
          icon={<PhoneOutlined />}
          value={deviceProps?.deviceModel || deviceProps?.deviceModel || '-'}
          loading={!deviceProps}
        />
      </Col>
      <Col lg={12} xs={24}>
        <StatCard
          title={t('table.lastUpdate')}
          value={
            deviceProps && deviceProps.update
              ? new Date(deviceProps.update).toLocaleString(
                  getLocaleString(language),
                )
              : '-'
          }
          icon={<CalendarOutlined />}
          loading={!deviceProps}
        />
      </Col>

      <Col lg={12} xs={24}>
        <StatCard
          valueStyle={{ fontSize: statsFontSize }}
          title={t('table.gsignal')}
          value={deviceProps?.gsignal ? `${deviceProps?.gsignal}%` : '-'}
          groupSeparator=""
          loading={!deviceProps}
        />
      </Col>
      <Col lg={12} xs={24}>
        <StatCard
          valueStyle={{ fontSize: statsFontSize }}
          title="ICCID"
          value={deviceProps?.iccid || '-'}
          groupSeparator=""
          loading={!deviceProps}
        />
      </Col>
      <Col lg={12} xs={24}>
        <StatCard
          valueStyle={{ fontSize: statsFontSize }}
          title="IMSI"
          value={deviceProps?.imsi || '-'}
          groupSeparator=""
          loading={!deviceProps}
        />
      </Col>
    </ContainerRow>
  );
};

export default TabPanesDetails;
